import { Divider } from "antd";

import ERPSyncDiagram from "../../assets/ERP同步圖.png";
import ERPUpdateDiagram from "../../assets/ERP更新圖.png";
import DatabaseConnection from "../../assets/資料庫連線圖.png";
import APIConnection from "../../assets/API 串接圖.png";
import DZWoLogic from "../../assets/達易工單邏輯圖.png";
import FieldMappingLogic from "../../assets/對接階層邏輯圖.png";
import FieldMappingDirect from "../../assets/欄位對接（直接填入）.png";
import FieldMappingCombine from "../../assets/欄位對接（組合填入）.png";
import FieldMappingTypeTransfer from "../../assets/欄位對接（型別轉換）.png";

import "./ManualContent.css";

const ManualContent = () => {
  return (
    <div className="manual-content">
      <div>
        <h1>ERP 同步手冊</h1>
        <Divider />
        為了讓達易報工系統可以顯示客戶端的工單資料，並使用達易系統進行報工流程，需要將客戶端
        ERP 中的工單資料與達易端資料庫對接上。
        <br />
        <br />
        工單資料分成未同步過的工單，以及已同步過的工單兩種狀態。
        未同步過的工單會在達易端建立新的工單資料，已同步過的工單則會更新既有的工單資料。
        <br />
        <br />
        以下說明如何使用 ERP Sync Blueprint 來設定同步與更新：
      </div>
      <div id="sync-workflow">
        <h2>流程</h2>
        <div className="paragraph-block">
          從未對接過客戶 ERP 的狀態開始，整個流程包含以下幾個步驟：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>確認客戶端連線方式​</li>
            <li>確認達易資料庫與客戶端資料對接規則</li>
            <li>確認需同步的工單條件</li>
            <li>確認更新工單的條件與頻率</li>
          </ul>
          <br />
          若已經對接過客戶端 ERP 資料，則直接依照「需同步的工單條件」同步客戶端
          ERP 中全新的工單，並依照「更新工單的條件」更新客戶端 ERP
          中與達易端內容有差異的工單。
          <br />
          <br />
          <img src={ERPSyncDiagram} alt="ERP Sync Diagram" height="200px" />
          <br />
          <br />
          <img src={ERPUpdateDiagram} alt="ERP Update Diagram" height="200px" />
        </div>
      </div>
      <div id="connection-method">
        <h2>客戶端連線方式​</h2>
        <div className="paragraph-block">
          若客戶端的工單資料儲存在資料庫中，請提供以下資訊：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>資料庫類型（Oracle、MySQL、SQL Server...）</li>
            <li>
              資料庫連線資訊（主機位址、連接埠、資料庫名稱、使用者名稱、密碼）
            </li>
          </ul>
          <img
            src={DatabaseConnection}
            alt="Database Connection"
            height="150px"
          />
          <br />
          <br />
          <br />
          若客戶端的工單資料需透過 API 取得，請提供以下資訊：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>API 文件</li>
            <li>API 認證方式（Basic Auth、Bearer Token、OAuth​...）</li>
            <li>回傳的欄位名稱如何對應到達易欄位</li>
          </ul>
          <img src={APIConnection} alt="API Connection" height="150px" />
        </div>
      </div>
      <div id="mapping-fields">
        <h2>達易與客戶端資料對接</h2>
        <div className="paragraph-block">
          對接原則上是以達易系統的工單邏輯對照客戶端的工單資料結構。
          達易提供必填與選填的欄位，客戶端需提供相對應的欄位資訊。
          <h3 id="dz-wo-logic">達易工單邏輯</h3>
          達易系統以大工單（Work
          Order）為同步單位，一張大工單底下必須有至少一個小工單（Work Order
          Operation），並以小工單為單位報工。大工單必須包含的資訊如：工單單號、物料名稱與編號、途程名稱、數量、是否急單等，
          小工單必須包含的資訊如：工序名稱與編號、設備或是報工站名稱、員工編號與名稱、數量等，除此之外達易亦提供更多選填欄位讓報工畫面更詳細。
          <br />
          <br />
          <img src={DZWoLogic} alt="DZ Wo Logic" height="300px" />
          <br />
          <h3 id="customer-wo-logic">客戶工單邏輯</h3>
          理解達易的工單邏輯後，再來確認客戶的工單邏輯。
          <br />
          <br />
          由於客戶工廠的工單規則不一定如達易的階層邏輯，因此要先了解客戶的規則，再適應到達易的規則，即可正確填入個欄位數值。
          <br />
          <br />
          有可能遇到的狀況，例如：
          客戶僅有大工單的概念，可能將其物料途程底下的工序作為小工單加入該大工單底下。或是客戶僅有小工單的概念，可能將所有小工單都指定到一個與小工單內容相同的大工單。
          <br />
          <br />
          <h3 id="mapping-rule">對接規則</h3>
          請提供達易端與客戶端對接的欄位資訊。
          <br />
          <br />
          如果是以資料庫對接，包含：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>工單資料表名稱</li>
            <li>欄位名稱與對應的達易欄位名稱</li>
          </ul>
          <br />
          如果是以 API 對接，包含：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>回傳資料的欄位名稱與對應的達易欄位名稱</li>
          </ul>
          <br />
          常見的對應邏輯有：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>
              客戶端特定欄位的值，直接對應到達易端所需的欄位值。例如：客戶端的物料編號欄位，直接對應到達易端的物料編號欄位。
              <br />
              <img
                src={FieldMappingDirect}
                alt="Field Mapping (Direct)"
                height="80px"
              />
            </li>
            <li>
              從多個欄位組合數值填入達易端的單一欄位。例如：客戶端的欄位型別是字串，而達易端的欄位型別是布林。
              <br />
              <img
                src={FieldMappingCombine}
                alt="Field Mapping (Combine)"
                height="80px"
              />
            </li>
            <li>
              客戶端特定欄位的值需經過轉換，才能對應到達易端所需的欄位值。例如：客戶端的欄位型別是字串，而達易端的欄位型別是布林。
              <br />
              <img
                src={FieldMappingTypeTransfer}
                alt="Field Mapping (Transfer)"
                height="80px"
              />
            </li>
          </ul>
        </div>
      </div>
      <div id="sync-conditions">
        <h2>同步條件</h2>
        <div className="paragraph-block">
          <h3 id="work-order">工單</h3>
          當客戶端出現了達易端未曾同步過的新工單，僅有符合特定條件的工單會被同步至達易端。
          因此，務必先確認客戶端工單同步的需求，訂定需同步的工單條件，避免不必要的工單資料被同步到達易端。
          <br />
          <br />
          常見的工單同步條件有：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>工單建立日期在某個時間點之後​</li>
            <li>工單狀態為「未完成」或「進行中」​</li>
            <li>工單屬於特定物料​</li>
            <li>工單屬於特定機台或報工站​</li>
          </ul>
          <br />
          請提供具體的條件說明，並確認這些條件能夠從客戶端的 ERP 系統中取得。
          <br />
          <br />
          <h3 id="passive-import-item">被動匯入項目</h3>
          由於目前的同步順序是優先填入工單資訊，再來，其中的物料、途程、設備、員工資訊會在達易端自行創建成列表，因此需要確認新同步的物料、設備、員工是否有曾經同步過。
          <br />
          <br />
          首先，搜尋達易資料庫是否已經存在該物料、途程、設備、員工，如果沒有的話，會創建一筆新的物料、途程、設備、員工資料；
          若有現存的話，會直接帶入舊的資訊。 因此這部分也要確認如何決定 ERP
          中的物料、設備、員工是否等於先前同步至 SFR
          中現存的物料、途程、設備、員工，因為這關乎到是否會重複新增同一個物料、途程、設備、員工。
          <br />
          <br />
          <img
            src={FieldMappingLogic}
            alt="Field Mapping Logic"
            height="350px"
          />
        </div>
      </div>
      <div id="update-conditions">
        <h2>更新工單的條件與頻率​</h2>
        <div className="paragraph-block">
          為了確保達易端的工單資料與客戶端 ERP
          中的工單資料一致，需定期檢查客戶端資料並更新至達易端的資料庫。
          然而，有可能不是所有變更過的工單都需要被更新，所以務必釐清符合哪些條件的工單才需要更新內容至達易端。
          <br />
          <br />
          常見的工單更新條件有：
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
            <li>工單的更新時間有變動</li>
            <li>工單的機台或報工站有變動</li>
            <li>工單的員工有變動</li>
          </ul>
          <br />
          達易目前預設的更新頻率是每 20
          分鐘確認一次是否有符合更新條件的工單，若有則進行更新。
          有其他特殊需求，亦可調整更新頻率，例如：每小時、每天等。
          但請注意，更新頻率過高可能會對客戶端的 ERP 系統造成負擔，請斟酌調整。
        </div>
      </div>
    </div>
  );
};

export default ManualContent;
